/**
 * SoliticsLogListener is responsible for handling log events by providing a listener callback
 * that processes log data. This class allows you to customize the behavior when a log event occurs.
 */
export class SoliticsLogListener {
    /**
     * Constructor to initialize the log listener with a custom callback function.
     * @param listener - A custom callback function to handle log events.
     * If not provided, the default behavior is logging the data to the console.
     */
    constructor(listener) {
        if (listener != undefined) {
            console.log('Custom listener is being used');
            this.onLog = listener;
        }
        else {
            console.log('Using default log listener');
            this.onLog = (data) => {
                console.log('[Solitics  default log] :', data);
            };
        }
    }
    /**
     * Executes the log listener callback with the given log data.
     * @param message - The log data that needs to be processed.
     */
    logMessage(message) {
        this.onLog(message);
    }
}
;
